export const APPROVAL_CONFIG = {
    DRAFT: {
        label: "Draft",
        color: "#374151",
        bg: "#F9FAFB",
        border: "#E5E7EB",
        dot: "#9CA3AF",
        iconName: "solar:document-bold",
    },
    SUBMITTED: {
        label: "Submitted",
        color: "#1E40AF",
        bg: "#EFF6FF",
        border: "#BFDBFE",
        dot: "#3B82F6",
        iconName: "solar:check-circle-bold",
    },
    UNDERREVIEW: {
        label: "Under Review",
        color: "#1E40AF",
        bg: "#EFF6FF",
        border: "#BFDBFE",
        dot: "#3B82F6",
        iconName: "solar:eye-bold",
    },
    APPROVED: {
        label: "Approved",
        color: "#065F46",
        bg: "#ECFDF5",
        border: "#A7F3D0",
        dot: "#10B981",
        iconName: "solar:shield-check-bold",
    },
    REJECTED: {
        label: "Rejected",
        color: "#991B1B",
        bg: "#FEF2F2",
        border: "#FECACA",
        dot: "#EF4444",
        iconName: "solar:shield-slash-bold",
    },
    CANCELPENDING: {
        label: "Cancel Pending",
        color: "#9A3412",
        bg: "#FFF7ED",
        border: "#FED7AA",
        dot: "#F97316",
        iconName: "solar:clock-circle-bold",
    },
    CANCELLED: {
        label: "Cancelled",
        color: "#4B5563",
        bg: "#F3F4F6",
        border: "#D1D5DB",
        dot: "#6B7280",
        iconName: "solar:close-circle-bold",
    },
};